export default {
	language: "Español",//西班牙語
	sanqi: {
		zhoushi: "Gráfico de tendencias",
		biaoti: "Transacciones en divisas encriptadas en mercados de alta liquidez",
		xiangqing: "Años de experiencia operativa, proporcionando a los usuarios un rico, flexible, estable, seguro y fiable entorno comercial",
		Global: "Distribución ecológica mundial",
		Bank: "Seguridad bancaria",
		Focus: "Centrarse en la experiencia del usuario",
		Convenient: "Facilitar el comercio",
		project: "Global project Extension and Operational Management System with Local Service Trade Centres in many countries",
		level: "Sistema bancario de cartera, control de riesgos financieros en tiempo real y autenticación multidimensional, equipo de seguridad financiera en la última década para proporcionar múltiples garantías de seguridad financiera",
		polish: "Pule cuidadosamente los detalles para que la interfaz de usuario y la interacción sean más cómodas paso a paso, y el comercio puede convertirse en un disfrute visual",
		Android: "Soporte para Android, Ios y web, control en tiempo real de la información del mercado, el mercado mundial y las transacciones en cualquier momento y en cualquier lugar",
		Download: "Descargar el cliente móvil y comerciar libremente en cualquier momento y en cualquier lugar",
		Palm: "Comercio de palma",
		Trade: "Comercio en cualquier momento y en cualquier lugar",
		flow: "Experiencia de flujo",
		Smooth: "El f Azbit-usa ionamiento suave le da una experiencia más agradable",
		Real: "Cotización en tiempo real",
		time: "Actualización en tiempo real para ayudarle a mantenerse al día con las tendencias del mercado",
		Rapid: "Carga rápida",
		Experience: "Experimente rápidamente y disfrute de lo que desea",
		Join: "Comience su viaje contractual",
		Please: "Introduzca su teléfono / correo electrónico en el cuadro de entrada de abajo para registrarse para Azbit-usa",
		enter: "Por favor, introduzca su correo electrónico o número de teléfono móvil",
		Register: "Registro",

		regulatory:'licencia regulatoria',
		regulatory_info:'Uncleblock es una compañía de servicios financieros y monetarios que cumple con las leyes y está bajo la supervisión del FINTRAC (Centro de Análisis de Informes y Transacciones Financieras de Canadá) de Canadá y la SEC de EE. UU. (Comisión de Bolsa y Valores de EE. UU.). Uncleblock cumplirá con todas las leyes y regulaciones aplicables en cada jurisdicción en la que opere en función de tener una licencia financiera. ',//
		canada:'Canadá (bajo supervisión)',
		certnum:'número de certificado reglamentario',
		dateissue:'fecha de emisión',
		veriurl:'URL de verificación canadiense',
		
		white_paper: 'papel blanco',
	},
	song: {
		low:'Introduzca una contraseña antigua',
	    jgsxf:"Deducción de los gastos de tramitación de los pedidos en virtud de contratos acelerados",
	    jgbj:"Deducción del principal de los contratos de velocidad máxima",
	    jgks:"Liquidación de pérdidas",
	    jgyl:"Cierre rápido de los contratos",
	    htcz:"Recarga de fondo",
	    htshcz:"Recarga de auditoría de fondo",
	    bbhr:"Transferencia de cuentas en moneda",
	    bbhc:"Cuenta de moneda",
	    pccl:"Liquidación de fondos",
	    gmsxf:"Gastos de venta deducidos",
	    ggsxf:"Presentación de transacciones apalancadas, deducidas las Comisiones",
	    ggbzj:"Presentación de transacciones apalancadas, deduciendo el margen",
	    gbdj:"Enviar a comprar congelado",
	    gbkc:"Presentar una deducción de compra",
	    gsdj:"Presentación de la congelación de las ventas",
	    gskc:"Presentación de la deducción por venta",
	    tbsbjs:"Falta de presentación de la moneda, disminución del saldo de bloqueo",
	    tbsbch:"Falló la retirada del saldo de bloqueo",
	    tbcg:"El éxito de la retirada de la moneda",
	    gyf:"Apalancamiento, cargo a un día",
	    gghr:"Cuenta apalancada transferida",
	    gghc:"Transferencia de la cuenta apalancada",
	    tbdj:"Solicitud de congelación del saldo",
	    tbkc:"Saldo deducible de la solicitud de retirada de moneda",
	    mhxh:"Consumo de caja ciega",
	    mhhq:"Adquisición de cajas ciegas",
	    msxf:"Deducción de los gastos de tramitación de los pedidos en virtud de contratos de segundos",
	    mbj:"Deducción del principal en el contrato de segundos",
	    mks:"Segundo orden contractual, liquidación de pérdidas",
	    myl:"Cierre de contratos de segundo orden, liquidación de beneficios",
	    mhr:"Cuenta de segundo contrato transferida",
	    mhc:"Cuenta de segundo contrato",
	    sfsczj:"Liberación de minas de bloqueo para aumentar los activos disponibles",
	    sfsckc:"Liberación de minas bloqueadas",
	    sczj:"Aumento de los activos congelados",
	    sckc:"Bloqueo de la mina menos activos disponibles",
	    scsy:"Activos disponibles para los ingresos procedentes de la explotación minera",
	    ahtcz:"Comentarios de recarga de fondo",
	    xcbx:"Liquidación rápida de las posiciones de los contratos, sin seguro efectivo, sin cambios en los fondos",
		bbjx:"transacción de moneda: el usuario cancela la compra y desbloquea",
		bbth:"Currency Transaction: User cancel Buy back",
		wtcd_t:"Reembolso de los gastos de tramitación",
		wtcd_b:"Depósito de devolución",
		bxju_p:"Importe de la indemnización",
		bxju_s:"Rescisión del contrato de seguro, deduciendo la cantidad asegurada",
		bxju_b:"Rescisión del contrato de seguro",
	},
	iesan: {
		li_a: 'Concéntrate y déjanos el resto.',
		li_b: 'Análisis automatizado de las inversiones - de acuerdo con la minería de bloqueo de Azbit-usa, puede personalizar las principales monedas de transacción de los inversores a medida que las ideas de negociación de un alto grado de configuración de la cuenta autónoma - de acuerdo con los diferentes tipos de clientes personalizados de la relación de retirada de fondos, la relación de posición, as í como la relación de alerta temprana. Un comerciante que se ocupa de los diferentes riesgos en el mercado. Reserva de la cuenta de préstamo de dinero - la plataforma proporciona la reserva de préstamo de dinero de la mina de bloqueo, sólo necesita el activo digital de la cuenta para alcanzar el 50% de la cuota de reserva, la aplicación puede obtener la financiación de la Plataforma de préstamo de dinero.',
		zuidi: 'Número mínimo',
		b_liord: "Orden de caja ciega",
		b_zhomg: "Ganador de la Caja ciega",
		b_xiaohao: "Consumo",
		b_mangheli: "Bolsa de regalo de caja ciega",
		b_qingsong: "Descubra fácilmente la bolsa de regalo super grande",
		b_kaiqi: "Abrir caja ciega",
		b_xuyao: "Abrir la Caja ciega actual requiere",
		b_dangqian: "Saldo actual",
		b_quxiao: "Cancelar",
		b_ok: "Determinar",
		b_cuocang: "Ganar dinero con cerradura",
		b_dindan: "Orden de caja ciega",
		b_genduo: "Cargar más",
		b_wabao: "Excavar un tesoro",
		b_jiandan: "La minería es más fácil y fácil de recompensar",
		b_cung: "Ganar dinero con cerradura",
		b_shouyi: "Ingresos totales",
		b_zhiyao: "Cantidad prometida",
		b_qianbao: "Saldo de la cartera",
		b_goumai: "Comprar",
		b_zhjuanbi: "Ganar dinero con cerradura",
		b_num: "Número de monedas depositadas",
		b_yuji: "Ingresos totales previstos",
		b_jin: "Cerca",
		b_rinianhua: "Anualización diaria de referencia",
		b_suochang: "Período de cierre",
		b_gtou: "Comprar",
		b_jilu: "Registro de bloqueo",
		b_biaohuao: "Número de proyecto",
		b_bizhong: "Moneda",
		b_shuliang: "Número de monedas depositadas",
		b_jixi: "Intereses totales",
		b_suocang: "Tiempo de cierre",
		b_shijan: "Fecha de vencimiento",
		b_zhuangtai: "Estado",
		b_jinxin: "En curso",
		b_jieshu: "Terminado",
		b_zhenqui: "Introduzca la cantidad correcta",
		b_tian: "Días",
		b_mei: "No más",
		b_maghe: "Caja ciega",
		b_wakuang: 'Bloqueo de minas',
		levermin: "Cantidad inferior al mínimo"
	},
	chongbi: {
		zaixian:"Servicio al cliente en línea",
		fuzhi:"Copiar etiqueta",
		huazhuan:"Remar",
		bizhong:"Moneda",
		keyong:"Saldo disponible",
		cong:"De",
		zhi:"A",
		num:"Cantidad transferida",
		shuru:"Introduzca el número de transferencias",
		whatsapp:"Introduzca la cuenta WhatsApp",
		youxiang:"Buzón de correo",
		superior: "Mis subordinados",
		tiem: "Tiempo",
		tit: "Mi miembro",
		group: "Número de equipos",
		not: "No miembro por el momento",
		qukuai: "Escuela de la cadena de bloques",
		fabi: "Transacciones en moneda francesa",
		gonggao: "AnAzbit-usaio",
		xitong: "Artículos del sistema",
		yonghu: "Soporte de usuario",
		bangzhu: "Centro de ayuda",
		shouyi: "Reglas de ingresos",
		xinwen: "Centro de información",
		xinshou: "Ayuda de novato",
		jiaoyi: "Reglas de transacción",
		kuaixun: "Noticias rápidas",
	},
	// 导航
	header: {
		wakuang: "Mina cerrada",
		miaohy: "Contrato de velocidad máxima",
		home: "Página principal",
		markets: "Mercado",
		fiat: "Transacciones en moneda francesa",
		c2c: "Transacción c2c",
		exchange: "Transacciones en moneda",
		lever: "Transacciones contractuales",
		myshop: "Mi tienda",
		assets: "Mis activos",
		help: "Centro de ayuda",
		login: "Inicio de sesión",
		sign: "Registro",
		accountSet: "Configuración de la cuenta",
		tradeLog: "Diario de las transacciones",
		receiveSet: "Configuración de la colección",
		identify: "Autenticación",
		jchange: "Cambio de moneda",
		logout: "Iniciar sesión de salida",
		themedark: "Modo nocturno",
		themeday: "Modo diurno",
	},
	// 登录注册
	lg: {
		login: "Inicio de sesión",
		register: "Registro",
	},
	// 首页
	home: {
		vol: "Cantidad 24h",
		c01: "Plataforma líder mundial para el comercio de activos digitales",
		c02: "Servicios seguros y fiables de comercio de activos digitales y gestión de activos para millones de usuarios en más de 130 países de todo el mundo",
		c03: "Seguro y confiable",
		c04: "5 años de experiencia en servicios financieros de activos digitales",
		c05: "Arquitectura distribuida profesional y sistema de defensa contra ataques DDoS",
		c06: "Diseño ecológico global",
		c07: "Establecimiento de centros de servicios de transacciones locales en varios países",
		c08: "Construir un ecosistema de cadena de bloques con múltiples formas de negocio",
		c09: "Usuario primero",
		c10: "Establecimiento de un mecanismo de indemnización anticipada",
		c11: "Establecimiento de un fondo de protección de los inversores",
		c12: "Transacciones de terminales multiplataforma en cualquier momento y en cualquier lugar",
		c13: "Cubre múltiples plataformas de Ios, Android y Windows, soportando todas las f Azbit-usa iones de negocio",
		sweep: "Descarga de código barrido",
		android: "Android",
		pinput: "Por favor, introduzca su dirección de correo electrónico o número de teléfono móvil",
		atrade: "Regístrese para una cuenta de estación global IE - X y comience su viaje comercial"
	},
	// 底部
	foo: {
		about: "Sobre nosotros",
		support: "Soporte de usuario",
		contact: "Contáctenos",
		qq: "Servicio al cliente QQ",
		email: "Buzón de correo de contacto",
	},
	// 行情
	market: {
		exchange: "Moneda",
		selfmarket: "Opcional",
		allmarket: "Todos los precios",
		symbol: "Pareja comercial",
		newprice: "El último precio",
		change: "Aumento",
		highprice: "El precio más alto",
		lowprice: "Precio más bajo",
		vol: "Cantidad 24h",
	},
	// 公共交易
	td: {
		purchase: "Precio de compra",
		transaction: "Precio de transacción",
		service: "Honorarios",
		profit: "Ganancias y pérdidas",
		buy: "Comprar",
		sell: "Vender",
		currency: "Moneda",
		num: "Cantidad",
		time: "Tiempo",
		limit: "Límite",
		price: "Precio unitario",
		method: "Método de pago",
		total: "Total",
		inwant: "Por favor, introduzca el deseo",
		do: "Acción",
		more: "Cargar más",
		nomore: "No más",
		nodata: "Datos no disponibles",
		trade: "Comercio",
		buynum: "Cantidad de compra",
		sellout: "Vender",
		buyin: "Comprar",
		all: "Todo",
		allbuy: "Comprar todo",
		allsell: "Vender todo",
		buytotal: "Por favor, introduzca la cantidad total que desea comprar",
		selltotal: "Por favor, introduzca la cantidad total que desea vender",
		buyallnum: "Por favor, introduzca la cantidad que desea comprar",
		sellallnum: "Por favor, introduzca la cantidad que desea vender",
		tradeTotal: "Total de transacciones",
		doceil: "Cancelación automática en segundos",
		place: "Ordenar",
		waitpay: "Pendiente de pago",
		paycode: "Código de pago",
		finished: "Hecho",
		ceiled: "Cancelado",
		payed: "Pagado",
		nofinish: "Incompleto",
		buyer: "Comprador",
		seller: "Vendedor",
		callWay: "Información de contacto",
		placeTime: "Tiempo de pedido",
		renum: "Número de referencia",
		canceil: "Cancelar",
		confirm: "Confirmar",
		pwd: "Introduzca la contraseña de la transacción",
		coincode: "Unidad monetaria",
		pcoin: "Seleccione una unidad monetaria"
	},
	// 法币交易
	fat: {
		// LegalPayDetail
		orderLog: "Registro de pedidos",
		fatdLog: "Transacciones en moneda francesa",
		shoper: "Comerciante",
		faLog: "Transacciones en moneda francesa",
		tdType: "Tipo de transacción",
		odStatus: "Estado del pedido",
		pwaitPay: "Por favor, espere el pago del comprador",
		odFinish: "Pedido completado",
		odCeil: "Pedido cancelado",
		odPay: "Pagado, por favor revise la información de pago",
		tdCeil: "Cancelar transacción",
		pCeil: "Por favor, no cancele la transacción si ha pagado al vendedor.",
		paySure: "Confirmación de pago",
		pdopay: "Por favor, confirme que ha pagado al vendedor",
		badClick: "Un clic malicioso congelará la cuenta directamente",
		receivePay: "Acuse de recibo",
		payReceive: "Por favor, confirme que el comprador le ha pagado",
		receivePays: "Confirmar colección",
		// LegalPay
		payPlease: "Por favor, pague",
		tdPrice: "Precio unitario de transacción",
		tdNum: "Número de transacciones",
		payinfo: "Información de pago",
		banknum: "Cuenta bancaria",
		realName: "Nombre real",
		shoperZname: "Sucursal comercial",
		shoperNum: "Cuenta de negocios",
		odCeil: "Cancelar pedido",
		imPay: "He pagado, haga clic en aceptar",
		// LegalSeller
		register_time: "Tiempo de registro",
		odtotal: "Hoja de montaje",
		odmonth: "Carta del 30",
		odfinish: "Hoja de terminación",
		odrate: "Tasa de terminación",
		submit: "Publicar",
		phone: "Teléfono móvil",
		mysell: "Mi venta",
		mybuy: "Mi compra",
		realAuth: "Autenticación de nombre real",
		advAuth: "Autenticación avanzada",
		linebuy: "Comprar en línea",
		linesell: "Venta en línea",
		tipPay: "Por favor, póngase en contacto con el vendedor en 24 horas para el pago, más allá de 24 horas se cancelará automáticamente.",
		notlow: "No puede ser inferior al mínimo",
		nothigh: "No se puede exceder el límite máximo",
		notnum: "No se puede exceder la cantidad máxima",
		// LegalShopDetail
		type: "Tipo",
		status: "Estado",
		seeOrder: "Ver orden",
		withdraw: "Retirada",
		abnormal: "Anormal",
		lowershelf: "Fuera del estante",
		protection: "En defensa de los derechos",
		apply: "Solicitud de protección",
		psType: "Por favor, seleccione un tipo",
		pselect: "Por favor, elija",
		alipay: "Alipay",
		wechat: "Wechat",
		bank: "Tarjeta bancaria",
		minNum: "Volumen mínimo de negociación",
		maxNum: "Volumen máximo de transacciones",
		wantBuy: "Comprar",
		pnums: "Por favor, introduzca la cantidad",
		pmin: "Introduzca el volumen mínimo de negociación",
		pmax: "Introduzca el volumen máximo de negociación",
		pnot: "El volumen máximo de negociación no puede ser inferior al volumen mínimo de negociación",
		// MyLegalShops
		myshops: "Mi tienda",
		name: "Nombre",
		fiatSub: "Moneda francesa a la que pertenece",
		shoper_balance: "Saldo del comerciante",
		enterShop: "Entrar en la tienda",
		// shop_legal_pay_detail
		payedWait: "Pagado, confirmado después de la verificación",
		yes: "Sí",
		no: "No",
		sd: "Saldo de bloqueo",
		journal: "Registro de saldos",
		business: "Comerciante",
		user: "Usuario",
		backdone: "Retirado",
		busbalance: "Saldo del comerciante",
		userbalance: "Saldo de usuario",
	},
	ctc: {
		ctc: "C2c",
		myRelease: "C2c que publiqué",
		myTrade: "C2c con el que trato",
		and: "Sí",
		balance: "Saldo",
		buynum: "Volumen de compra",
		sellnum: "Cantidad vendida",
		bankTransfer: "Transferencia bancaria",
		payim: "Debo pagarlo yo mismo",
		pbuyNum: "Por favor, introduzca la cantidad de compra",
		pprice: "Por favor, introduzca el precio unitario",
		payway: "Por favor, seleccione el método de pago",
		psellNum: "Por favor, introduzca la cantidad vendida",
		suerePlace: "Confirmar el pedido?",
		detail: "Detalles",
		payinfo: "Información de pago",
		Payee: "Beneficiario",
		total: "Total",
		name: "Nombre",
		cardnum: "Número de tarjeta",
		receivePay: "Confirmar colección",
		ceilConfirm: "Confirmar la cancelación?",
		paySeller: "Por favor, confirme que ha pagado al vendedor. Haga clic malicioso para congelar la cuenta.",
		payBuyer: "Por favor, confirme que ha comprado información de pago",
		account: "Número de cuenta",
		sellerPay: "Por favor, confirme que el comprador le ha pagado?",
		payattion: "Por favor, pague al vendedor tan pronto como sea posible después de la confirmación del pago. Haga clic maliciosamente para congelar la cuenta.",
		log: "C2c completó el pedido",
	},
	// 合约
	lever: {
		purchase: "Precio de compra",
		Expected: "Ganancias y pérdidas previstas",
		countdown: "Cuenta regresiva",
		second: "Segundos",
		jiaoyinum: "Cantidad",
		houmaicg: "Compra exitosa",
		nowentrust: "Delegación actual",
		hisentrust: "Delegación histórica",
		lvchi: "Posición contractual",
		all: "Todo",
		or: "O",
		gotrade: "Iniciar el comercio",
		tdrecord: "Transacciones",
		dealed: "Trato hecho",
		notdeal: "No hay trato",
		loading: "Cargando...",
		entotal: "Total autorizado",
		canuse: "Disponible",
		std: "Comercio de mercado",
		xtd: "Negociación limitada",
		pprice: "Por favor, introduzca un precio",
		phand: "Por favor, introduzca la cantidad de compra",
		phandsell: "Por favor, introduzca la cantidad vendida",
		pwd: "Contraseña",
		ppwd: "Introduzca la contraseña de la transacción",
		psw: "Contraseña de transacción",
		equal: "Igual",
		times: "Doble",
		timed: "Múltiplo",
		hand: "Mano",
		miao: "s",
		miaos: "S",
		// miaos: "Segundos",
		hands: "Número de manos",
		ptimes: "Por favor, seleccione múltiplos",
		phands: "Por favor, seleccione el número de manos",
		contractVal: "Valor de mercado contractual",
		bail: "Margen",
		canBail: "Margen disponible",
		charge: "Cargo por servicios de transacción",
		domore: "Comprar (hacer mucho)",
		doshort: "Vender (corto)",
		dmore: "Hacer más",
		dshort: "Corta",
		sureOd: "Confirmar pedido",
		noless: "El número de manos no puede ser inferior a",
		nomore: "El número de manos no puede ser mayor que",
		tdnum: "Volumen de comercio",
		risk: "Tasa de riesgo",
		allloss: "Ganancia o pérdida total de posición",
		onehouse: "Cierre de un botón",
		type: "Tipo",
		entrustPrice: "Precio de Comisión",
		openPrice: "Precio de apertura",
		nowPrice: "Precio actual",
		styPrice: "Precio de parada",
		stsPrice: "Precio de parada",
		openTime: "Tiempo de apertura",
		closeTime: "Tiempo de cierre",
		rate: "Honorarios",
		nightFee: "Tarifa nocturna",
		loss: "Ganancias y pérdidas",
		setloss: "Establecer parada de ganancia",
		expectProfit: "Ganancias esperadas",
		expectLoss: "Pérdida esperada",
		allClose: "Todas las posiciones cerradas",
		moreClose: "Sólo pingduoshan",
		nullClose: "Sólo hojas planas",
		sureClose: "Confirmar el cierre?",
		thanZearo: "El valor establecido debe ser mayor que 0",
		listin: "En la lista",
		tdin: "En el comercio",
		closein: "En liquidación",
		closed: "Cerrado",
		revoked: "Revocado",
		revokeOrder: "Confirmar la cancelación de la orden?",
		ping: "Cierre",
		revoke: "Retiro",
		sureping: "Cerrar definitivamente?",
		thanzone: "El valor establecido debe ser mayor que 0",

		profitability: 'Rentabilidad',
		profit_: 'ganancia',
	},
	// 币币
	cuy: {
		direction: "Dirección",
		total: "Total",
		price: "Precio",
		sell: "Vender",
		buy: "Comprar",
		allStation: "Comercio total",
		buyPrice: "Precio de compra",
		buynum: "Volumen de compra",
		sellPrice: "Precio de venta",
		sellnum: "Cantidad vendida",
		tdPrice: "Volumen de transacción",
		or: "O",
		tdStart: "Iniciar el comercio",
		pbPrice: "Por favor, introduzca el precio de compra",
		pbNum: "Por favor, introduzca la cantidad de compra",
		psPrice: "Por favor, introduzca el precio de venta",
		psNum: "Por favor, introduzca la cantidad vendida",
		fixPrice: "Negociación limitada",
		Mtrans: "Comercio de mercado",
		available: "Disponible",
		revoke: "Revocar",
		loading: "En carga",
		confirmCancel: "¿Estás seguro de que quieres deshacerlo?",
		confirm: "OK",
		cancel: "Cancelar",
		nomore: "No hay más datos",
		evelPrice: "Precio medio de transacción"
	},
	// 资产
	asset: {
		text1:"Dirección llena de monedas",
		text2:"Por favor, introduzca una dirección llena de monedas",
		text3:"Cantidad de llenado",
		text4:"Por favor, introduzca el número de monedas completas",
		text5:"Enviar información de recarga",
		miao_account: "Cuenta de contratos acelerada",
		assets: "Activos",
		currency_account: "Cuenta de moneda",
		lever_account: "Cuenta contractual",
		fince_account: "Cuenta en moneda francesa",
		change_account: "Cuenta de negociación",
		assets_hua: "Transferencia de fondos",
		all_assets: "Conversión total de activos",
		currency: "Moneda",
		canuse: "Disponible",
		frezz: "Congelado",
		conversion: "Plegable",
		charging: "Moneda llena",
		withdraw: "Monedas",
		address_bind: "Dirección de moneda vinculante",
		address_withdraw: "Gestión de direcciones de monedas",

		record: "Registro",
		address_charge: "Dirección llena de monedas",
		address_width: "Dirección de la moneda",
		copy: "Copiar",
		ercode: "Código QR",
		reminder: "Consejos cálidos",
		notcharge: "No recargue ningún activo que no sea USDT a la dirección anterior, de lo contrario, los activos no se recuperarán",
		support: "La moneda llena sólo soporta el método simple enviado. La moneda llena con otro método (enviar todos) no puede ser registrada temporalmente, por favor entienda.",
		minnum: "Cantidad mínima de billetes",
		ratenum: "Honorarios",
		havenum: "Cantidad recibida",
		from: "De",
		to: "A",
		transfer: "Remar",
		tfnum: "Cantidad transferida",
		ptfnum: "Por favor, introduzca el mínimo",
		dtfnum: "Número de transferencias",
		canbalance: "Saldo disponible",
		sureConfirm: "Confirmar transferencia",
		moneyRecord: "Registros financieros",
		pNum: "Introduzca el número de transferencias",
		leverUse: "Cuenta de contrato disponible",
		legalUse: "Cuenta en moneda francesa disponible",
		changeUse: "Cuenta de negociación disponible",
		look: "Ver",
		chargeRecord: "Registro de llenado de monedas",
		status: "Estado de seguimiento",
		noopen: "Esta característica no está abierta en este momento",
		enterAdderses: "Introduzca la dirección de la moneda",
		enterNum: "Por favor, introduzca el número de monedas",
		lessMin: "El número de monedas retiradas introducidas es inferior al mínimo",
		tips01: "No recargar ningún otro activo a la dirección anterior, de lo contrario el activo no será recuperable.",
		tips02: "La moneda llena sólo soporta el método simple enviado, y la moneda llena con otro método (enviar todo) no puede ser registrada temporalmente, por favor entienda.",
		beizhu: "Observaciones",
		pbeizhu: "Por favor, introduzca comentarios",
		add: "Añadir",
		addressList: "Lista de direcciones",
		delete: "Borrar",
		norec: "Sin registro",
		selectCurrency: "Por favor, seleccione la moneda",
		chainType: "Tipo de cadena"
	},
	// 账户设置
	set: {
		mycode2: "Mi código de autorización",
		copycode2: "Copiar Código de autorización",
		uaccont: "Nivel de Seguridad de su cuenta:",
		strong: "Fuerte",
		middle: "Medio",
		weak: "Débil",
		min: "Bajo",
		heigh: "Alto",
		complete: "Mejorar más información para garantizar la seguridad de la cuenta",
		mycode: "Mi código de invitación",
		copycode: "Copiar Código de invitación",
		bindphone: "Teléfono vinculado",
		bindemail: "Enlazar buzón de correo",
		loginpwd: "Contraseña de inicio de sesión",
		noBind: "Sin consolidar",
		binds: "Vinculante",
		bind: "Unbinding",
		binded: "Atado",
		net: "Hay un riesgo de robo en su cuenta de Internet. Le recomendamos que cambie su contraseña regularmente para proteger su cuenta.",
		reset: "Modificar",
		setPsw: "Establecer contraseña de transacción para garantizar la seguridad de la transacción.",
		goSet: "Ir a la configuración",
		bindAccount: "Cuenta de cambio vinculante",
		duihuan: "Cuenta vinculante para el intercambio de puntos",
		copysuccess: "Copia exitosa",
		copyfail: "Falló la replicación",
		recopy: "Por favor, copie de nuevo",
		account: "Cuenta",
		detail: "Detalles",
		val: "Cantidad",
		forgetPsw: "Olvida la contraseña",
		code: "Código de verificación",
		getCode: "Obtener Código de verificación",
		setPsw: "Establecer contraseña",
		enterPsw: "Introduzca su contraseña",
		pswFalse: "Contraseña inconsistente introducida dos veces",
		enterPswagain: "Por favor, introduzca la contraseña de nuevo",
		jsetPsw: "Establecer contraseña de transacción",
		jenterPsw: "Introduzca la contraseña de la transacción",
		jenterPswagain: "Introduzca la contraseña de la transacción de nuevo",
		enterAccount: "Por favor, introduzca el número de cuenta",
		enterCode: "Introduzca el Código de verificación",
		accountFalse: "El número de teléfono o cuenta de correo electrónico que ha introducido no se ajusta a las reglas!",
		second: "Segundos",
		sendCode: "Enviar Código de verificación",
		sendsucc: "Enviado con éxito",
		enterPswTwo: "Introduzca su contraseña dos veces",
		rest: "Remanente",
		yes: "Sí",
		no: "No",
		yorn: "Establecer contraseña de transacción",
	},
	// 身份认证
	auth: {
		identity: "Autenticación",
		name: "Nombre",
		idcard: "Documento de identidad",
		upimg: "Por favor, suba la foto del certificado, la primera es la cara, la segunda es la cara, la tercera es la foto frontal del certificado de mano.",
		submit: "Enviar",
		auditing: "En auditoría...",
		certified: "Certificado!",
		pname: "Por favor, introduzca un nombre",
		pidcard: "Introduzca el número de identificación",
		pimg: "Por favor, suba la foto del certificado!",
	},
	// 收款方式
	seting: {
		pmethod: "Método de recogida",
		truename: "Nombre real",
		opening: "Nombre del Banco de apertura de cuentas",
		bank: "Número de tarjeta bancaria",
		alipay: "Cuenta Alipay",
		wename: "Apodo Wechat",
		wechat: "Cuenta Wechat",
		pname: "Por favor, introduzca un nombre real",
		popen: "Introduzca el nombre del Banco de apertura de la cuenta",
		pcard: "Por favor, introduzca el número de tarjeta bancaria",
		palipay: "Por favor, introduzca la cuenta Alipay",
		pwname: "Introduzca el apodo de Wechat",
		pwaccount: "Introduzca su cuenta Wechat",
		pimg1: "Código de recogida de Wechat",
		pimg2: "Paypal Collection Code"
	},
	// 帮助中心
	news: {
		seeall: "Ver todo",
		helpcenter: "Centro de ayuda",
		back: "Volver",
		gonggao: "An Azbit-usa io"
	},
	//登录
	login: {
		welcome: "Bienvenido a iniciar sesión",
		phoneLogin: "Conexión móvil",
		emailLogin: "Inicio de sesión del buzón de correo",
		account: "Número de cuenta",
		psw: "Contraseña",
		login: "Inicio de sesión",
		nouser: "Todavía no es un usuario de IE - X?",
		goRegister: "Regístrese ahora y comience a comerciar en las principales plataformas de comercio de activos digitales del mundo.",
		registerFree: "Registro gratuito",
		psw6: "La contraseña no puede ser inferior a seis dígitos"
	},
	register: {
		register: "Registro",
		phoneRegister: "Registro de teléfonos móviles",
		emailRegister: "Registro de buzón de correo",
		country: "Nacionalidad",
		enterPhone: "Por favor, introduzca su número de teléfono móvil",
		enterEmail: "Por favor, introduzca el buzón de correo",
		psw16: "Contraseña entre 6 y 16 bits",
		inviteCode: "Código de invitación",
		sel: "Requerido",
		sel2: "No obligatorio",
		read: "He leído y estoy de acuerdo",
		xieyi: "Protocolo de usuario",
		tips01: "La información sobre la nacionalidad no se puede modificar después del registro, por favor asegúrese de elegir la verdad.",
		tips02: "Los mensajes de autenticación pueden ser mal juzgados como spam. Por favor, tenga en cuenta que los mensajes de autenticación son recibidos.",
		tips03: "Por favor, guarde su cuenta IE - X y contraseña de inicio de sesión correctamente.",
		tips04: "No use la misma contraseña de inicio de sesión que otros sitios.",
		emailFalse: "El buzón que ha introducido no cumple con las reglas"
	},
	// 积分兑换
	jc: {
		title: "Plataforma beau de activos digitales convertibles JC",
		balance: "Saldo",
		cannum: "Número de JC disponibles",
		new: "El último precio",
		exnum: "Cantidad convertida",
		pnum: "Introduzca el número de JC",
		canex: "Cantidad de Beau convertible",
		exnow: "Cambio inmediato",
		record: "Registro de cambio",
		exprice: "Precio de cambio",
		extime: "Tiempo de cambio",
		not: "Número insuficiente de puntos disponibles",
		usenum: "Número de JC utilizados",
		out: "Salir",
		gotd: "Para comerciar"

	}

}



// WEBPACK FOOTER //
// ./src/lang/es.js